<template>
  <div class="input-text-v2">
    <input
      v-if="!rows"
      :type="type"
      v-model="internalValue"
      :placeholder="placeholder"
      :min="min"
      :max="max"
      :minlength="minlength"
      :maxlength="maxlength"
      :readonly="readonly"
      :class="{ error }"
    />
    <textarea
      v-else
      v-model="internalValue"
      :placeholder="placeholder"
      :minlength="minlength"
      :maxlength="maxlength"
      :readonly="readonly"
      :rows="rows"
      :class="{ error }"
    />

    <div v-if="isDisplayCount" class="count">
      <span>{{ internalValue.length }}</span>
      <span>/</span>
      <span>{{ maxlength }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    value: {
      type: String as PropType<string>,
      default: "",
    },
    initialValue: String as PropType<string>,
    type: {
      type: String as PropType<string>,
      default: "text",
    },
    placeholder: String as PropType<string>,
    min: Number as PropType<number>,
    max: Number as PropType<number>,
    minlength: Number as PropType<number>,
    maxlength: Number as PropType<number>,
    readonly: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    rows: {
      type: Number as PropType<number>,
      default: 0,
    },
    isDisplayCount: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    error: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  created() {
    if (!this.value && this.initialValue) {
      this.$emit("input", this.initialValue);
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(value: string) {
        this.$emit("input", value);
      },
    },
  },
});

interface Props {
  value: string;
  initialValue?: string;
  type?: string;
  placeholder: string;
  min?: number;
  max?: number;
  minlength?: number;
  maxlength?: number;
  readonly?: boolean;
  rows?: number;
  isDisplayCount?: boolean;
  error: boolean;
}

interface Data {}

interface Computed {
  internalValue: string;
}

interface Methods {}
</script>

<style lang="scss" scoped>
.input-text-v2 {
  display: flex;
  flex-direction: column;
}

.count {
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
  margin-right: 5px;
  margin-bottom: calc(-1em - 5px);
  color: var(--color-text-low);
}

input {
  box-sizing: border-box;
  border: 1px solid var(--color-primary);
  border-radius: var(--radius-xs);
  padding: 10px 20px;
  background-color: var(--color-background-normal);
  color: var(--color-text-normal);

  &::placeholder {
    color: var(--color-text-low);
  }

  &:read-only {
    border-color: var(--color-border);
  }

  &.error {
    border-color: var(--color-warning);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px var(--color-focus-ring);
  }
}

textarea {
  box-sizing: border-box;
  border: 1px solid var(--color-primary);
  border-radius: var(--radius-xs);
  padding: 10px 20px;
  resize: none;
  background-color: var(--color-background-normal);
  color: var(--color-text-normal);

  &::placeholder {
    color: var(--color-text-low);
  }

  &:read-only {
    border-color: var(--color-border);
  }

  &.error {
    border-color: var(--color-warning);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px var(--color-focus-ring);
  }
}
</style>
